import { UPDATE_TEXT_INPUT } from './actions';

export const updateTextInput = (payload) => ({
  type: UPDATE_TEXT_INPUT,
  payload
});

export const loadInitialText = () => ({ type: 'LOAD_INITIAL_TEXT' });
